/* ==========================================================================
   RefinedSupps - custom Shopify theme
   AW Media & Marketing, job 1664

   Everything here talks to Shopify's real APIs. The cart drawer and the header
   count are re-rendered by the Section Rendering API rather than rebuilt in
   JavaScript, so the money formatting, the discounts and the free delivery
   maths only ever live in Liquid.
   ========================================================================== */
(function () {
  'use strict';

  var RS = window.RS || {};
  var routes = RS.routes || {};
  var strings = RS.strings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- drawers */
  // class names below MUST match theme.css: .open, .show, .stuck.
  // Inventing is-open here is what left every drawer invisible.
  var scrim = $('[data-scrim]');
  var openDrawer = null;
  var lastFocus = null;

  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function open(name) {
    var el = $('[data-drawer="' + name + '"]');
    if (!el) return;
    if (openDrawer && openDrawer !== el) close();

    lastFocus = document.activeElement;

    // Force a reflow, then add the class synchronously. This used to sit inside
    // requestAnimationFrame, which browsers throttle in a background tab and on
    // iOS in Low Power Mode. When rAF does not fire the drawer unhides but never
    // gets .open, so it stays visibility:hidden and nothing inside it can be
    // tapped. Reading offsetWidth is enough to let the transition run.
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('open');

    if (scrim) {
      scrim.hidden = false;
      void scrim.offsetWidth;
      scrim.classList.add('open');
    }
    document.body.classList.add('locked');
    openDrawer = el;

    var f = focusables(el)[0];
    if (f) f.focus();

    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function close() {
    if (!openDrawer) return;
    var el = openDrawer;
    el.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    document.body.classList.remove('locked');

    var name = el.getAttribute('data-drawer');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

    window.setTimeout(function () {
      el.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 300);

    openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      // the basket button is a real link to /cart, so it still works with no JS
      if (opener.getAttribute('data-open') === 'cart' && RS.cartType !== 'drawer') return;
      e.preventDefault();
      open(opener.getAttribute('data-open'));
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); close(); return; }
    if (scrim && e.target === scrim) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) { close(); return; }
    if (e.key !== 'Tab' || !openDrawer) return;
    var f = focusables(openDrawer);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------------- cart */
  function sectionsToRefresh() {
    return ['cart-drawer', 'header'];
  }

  function applySections(data) {
    var secs = data && data.sections;
    if (!secs) return;

    Object.keys(secs).forEach(function (id) {
      var html = secs[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');

      if (id === 'cart-drawer') {
        var fresh = $('[data-drawer="cart"]', doc);
        var live = $('[data-drawer="cart"]');
        if (fresh && live) {
          var wasOpen = live.classList.contains('open');
          var wasHidden = live.hidden;
          live.innerHTML = fresh.innerHTML;
          live.hidden = wasHidden;
          if (wasOpen) live.classList.add('open');
        }
      } else if (id === 'header') {
        var freshCount = $('[data-cart-count]', doc);
        var liveCount = $('[data-cart-count]');
        if (freshCount && liveCount) {
          liveCount.textContent = freshCount.textContent;
          liveCount.hidden = freshCount.hidden;
        }
      }
    });
  }

  function cartError(msg) {
    var body = $('[data-cart-body]');
    if (!body) { window.alert(msg); return; }
    var p = document.createElement('p');
    p.className = 'cart-err';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    body.insertBefore(p, body.firstChild);
  }

  function addToCart(form, button) {
    var data = new FormData(form);
    data.append('sections', sectionsToRefresh().join(','));
    data.append('sections_url', window.location.pathname);

    var label = button ? button.querySelector('[data-add-text]') : null;
    var original = label ? label.textContent : '';
    if (button) button.disabled = true;
    if (label) label.textContent = strings.adding || '...';

    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) {
          // Shopify answers 422 with a description when stock ran out mid-add
          cartError(json.description || json.message);
          open('cart');
          return;
        }
        applySections(json);
        if (label) label.textContent = strings.added || original;
        if (RS.cartType === 'drawer') open('cart');
      })
      .catch(function () {
        // never leave them stuck: fall back to the real basket page
        window.location.href = routes.cart;
      })
      .then(function () {
        window.setTimeout(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = original;
        }, 1200);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[data-add-btn]') || form.querySelector('[name="add"]'));
  });

  function changeLine(line, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionsToRefresh().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        applySections(json);
        // the basket PAGE is not one of those sections, so reload rather than
        // leave a stale total sat on screen
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-qty-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(parseInt(rm.getAttribute('data-line'), 10), 0);
      return;
    }

    var btn = e.target.closest('[data-qty-up],[data-qty-down]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;

    var v = parseInt(input.value, 10) || 0;
    v = btn.hasAttribute('data-qty-up') ? v + 1 : v - 1;
    if (v < 0) v = 0;
    input.value = v;

    var line = input.getAttribute('data-line');
    if (line) changeLine(parseInt(line, 10), v);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input][data-line]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    changeLine(parseInt(input.getAttribute('data-line'), 10), v);
  });

  /* -------------------------------------------------------- variant picker */
  /* The flavour picker is buttons with colour dots, because that is the approved
     design and the stylesheet is built on .swatch / .dot / .soldout. Hydra Flow
     is 18 flavours with 4 in stock, so sold out ones stay on screen and marked
     rather than hidden: hiding them makes the range look smaller and buries the
     back in stock signup that Restock Rocket is there to catch. */
  function VariantPicker(root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('form[action*="/cart/add"]', root);
    var idInput = form && form.querySelector('[name="id"]');
    var priceBox = $('[data-price-box]', root);
    var perServe = $('[data-perserve]', root);
    var addBtn = $('[data-add-btn]', root);
    var addText = addBtn && addBtn.querySelector('[data-add-text]');
    var notify = $('[data-notify]', root);
    var sku = $('[data-sku]', root);
    var galMain = $('[data-gal-main]', root);

    function groups() { return $$('[data-opt]', root); }

    function selected() {
      return groups().map(function (g) {
        var on = g.querySelector('.swatch.on');
        return on ? on.getAttribute('data-swatch') : null;
      });
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] === null) continue;
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var v = match(selected());

      groups().forEach(function (g) {
        var on = g.querySelector('.swatch.on');
        var label = g.querySelector('[data-swatch-label]');
        if (label && on) label.textContent = on.textContent.trim();
      });

      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = strings.soldOut || '';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceBox && v.price_html) priceBox.innerHTML = v.price_html;

      // the sticky bar carries its own form, so it needs the same variant
      var stickyId = $('[data-sticky-id]');
      var stickyPrice = $('[data-sticky-price]');
      var stickyBtn = $('[data-stickybuy] [data-add-btn]');
      if (stickyId) stickyId.value = v.id;
      if (stickyPrice && v.price_html) stickyPrice.innerHTML = v.price_html;
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        var st = stickyBtn.querySelector('[data-add-text]');
        if (st) st.textContent = v.available ? (strings.add || '') : (strings.soldOut || '');
      }
      if (sku) sku.textContent = v.sku || '';

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? (strings.add || '') : (strings.soldOut || '');
      }
      if (notify) notify.hidden = v.available;

      // the per serving line is derived from THIS variant's price, so it moves
      // with the flavour rather than sitting on the first one for ever. The
      // string is formatted in Liquid, so the currency can never drift.
      if (perServe) {
        if (v.per_serve) {
          perServe.textContent = v.per_serve;
          perServe.hidden = false;
        } else {
          perServe.hidden = true;
        }
      }

      if (galMain && v.featured_media_url) {
        galMain.src = v.featured_media_url;
        $$('[data-media-thumb]', root).forEach(function (t) {
          t.classList.toggle('on', t.getAttribute('data-media-thumb') === String(v.featured_media_id));
        });
      }

      if (window.history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var sw = e.target.closest('.swatch');
      if (sw) {
        e.preventDefault();
        var group = sw.closest('[data-opt]');
        if (!group) return;
        $$('.swatch', group).forEach(function (b) {
          b.classList.remove('on');
          b.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('on');
        sw.setAttribute('aria-checked', 'true');
        update();
        return;
      }

      var more = e.target.closest('[data-swatch-more]');
      if (more) {
        e.preventDefault();
        var box = more.closest('.swatches');
        if (!box) return;
        // A toggle, not a one-way door: 42 flavours open pushes the size
        // picker and ADD TO CART a long way down, so they can close it again.
        var open = more.getAttribute('aria-expanded') === 'true';
        $$('.swatch.extra', box).forEach(function (b) {
          b.classList[open ? 'add' : 'remove']('hide');
        });
        more.setAttribute('aria-expanded', open ? 'false' : 'true');
        var txt = more.querySelector('[data-swatch-more-text]');
        var label = more.getAttribute(open ? 'data-more-label' : 'data-less-label');
        if (txt && label) txt.textContent = label;
        return;
      }

      var thumb = e.target.closest('.gal-thumb');
      if (thumb && galMain) {
        e.preventDefault();
        var src = thumb.getAttribute('data-thumb');
        if (src) galMain.src = src;
        $$('.gal-thumb', root).forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
      }
    });

    // keyboard: a radiogroup should answer to the arrow keys
    root.addEventListener('keydown', function (e) {
      var sw = e.target.closest('.swatch');
      if (!sw) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var group = sw.closest('[data-opt]');
      var all = $$('.swatch:not(.hide)', group);
      var i = all.indexOf(sw);
      var next = all[e.key === 'ArrowRight' ? i + 1 : i - 1];
      if (!next) return;
      e.preventDefault();
      next.click();
      next.focus();
    });

    update();
  }

  // Same trap as motion.js: bound once against a snapshot of the DOM. The theme
  // editor re-renders a section on every keystroke, and the new markup would
  // have no picker attached at all. Re-run on Shopify's editor events, and mark
  // what has already been wired so nothing gets two listeners.
  function initPickers(root) {
    $$('[data-product-root]', root || document).forEach(function (el) {
      if (el.dataset.pickerReady) return;
      el.dataset.pickerReady = '1';
      VariantPicker(el);
    });
  }
  initPickers(document);

  function initStickyBuy(root) {
    var bar = $('[data-stickybuy]', root || document) || $('[data-stickybuy]');
    var row = $('.addrow', root || document) || $('.addrow');
    if (!bar || !row || !('IntersectionObserver' in window)) return;
    if (bar.dataset.stickyReady) return;
    bar.dataset.stickyReady = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.hidden = !passed;
        bar.classList.toggle('show', passed);
      });
    }, { threshold: 0 }).observe(row);
  }

  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      initPickers(e.target || document);
      initStickyBuy(e.target || document);
    });
  });

  /* ------------------------------------------------------ predictive search */
  var sInput = $('[data-predictive-input]');
  var sResults = $('[data-predictive-results]');
  if (sInput && sResults && routes.predictive_search) {
    var timer = null;
    var controller = null;

    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      window.clearTimeout(timer);
      if (controller) controller.abort();

      if (q.length < 2) { sResults.innerHTML = ''; return; }

      timer = window.setTimeout(function () {
        controller = new AbortController();
        var url = routes.predictive_search +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = $('[data-predictive-inner]', doc);
            sResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            sResults.innerHTML = '';
          });
      }, 220);
    });
  }

  /* ------------------------------------------------- collection sort + filters */
  document.addEventListener('change', function (e) {
    var auto = e.target.closest('[data-auto-submit]');
    if (!auto) return;
    var form = auto.closest('form');
    if (form) form.submit();
  });

  /* -------------------------------------------------------- sticky buy bar */
  /* Shows once the real buy row has scrolled past, hides again when it comes
     back. Uses an observer rather than a scroll handler so it costs nothing
     while the page is just sitting there. */
  initStickyBuy(document);

  /* ---------------------------------------------------------- sticky header */
  var hdr = $('.hdr--sticky');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('stuck', window.pageYOffset > 8);
    }, { passive: true });
  }
})();
